import { lazy } from "react";
import Authentication from "./Authentication.js";
import Authorization from "./Authorization.js";


/****Layouts*****/
const DataSecurityLayout  = lazy(() => import("../layouts/DataSecurityLayout.js"));
const CurriculumLayout = lazy(() => import("../layouts/CurriculumLayout.js"));
const CurriculumDetailsLayout = lazy(() => import("../layouts/CurriculumDetailsLayout.js"));
const BlogsHomeLayout = lazy(() => import("../layouts/BlogsHomeLayout.js"));
const BlogDetailLayout = lazy(() => import("../layouts/BlogDetailLayout.js"));
const FormsHomeLayout = lazy(() => import("../layouts/FormsHomeLayout.js"));
const AdminFormDetailsLayout = lazy(() => import("../layouts/AdminFormDetailsLayout.js"));
const FormDetailLayout = lazy(() => import("../layouts/FormDetailLayout.js"));
const CommonLayout = lazy(() => import("../layouts/CommonLayout.js"));
const ProfileLayout = lazy(() => import("../layouts/ProfileLayout.js"));
const AdminHomeLayout = lazy(() => import("../layouts/AdminHomeLayout.js"));
const AdminCurriculumDetailsLayout = lazy(() => import("../layouts/AdminCurriculumDetailsLayout.js"));
const AdminUsersLayout = lazy(() => import("../layouts/AdminUsersLayout.js"));


/*****Routes******/

/**Pages*/
const LoginView = lazy(() => import("../views/dss/login/LoginView.js"));
const RegisterView = lazy(() => import("../views/dss/register/RegisterView.js"));
const RegisterSuccessView = lazy(() => import("../views/dss/register/RegisterSuccessView.js"));
const ProfileActivationView = lazy(() => import("../views/dss/register/ProfileActivationView.js"));
const ForgotUserNameView = lazy(() => import("../views/dss/forgotUserName/ForgotUserNameView.js"));
const ForgotPasswordView = lazy(() => import("../views/dss/forgotPassword/ForgotPasswordView.js"));
const UnauthorizedView = lazy(() => import("../views/dss/UnauthorizedView.js"));
const CompleteProfileView = lazy(() => import("../views/dss/completeProfile/CompleteProfileView.js"));

const CurriculumsView = lazy(() => import("../views/user/curriculums/CurriculumsView.js"));
const CurriculumDetailsView = lazy(() => import("../views/user/curriculums/details/CurriculumDetailsUserView.js"));
const FormSubmitView = lazy(() => import("../views/FormSubmitView.js"));
const FormViewerView = lazy(() => import("../views/FormViewerView.js"));

const BlogsHomeView  = lazy(() => import("../views/user/blogs/BlogsHomeView.js"));
const BlogDetailsView  = lazy(() => import("../views/user/blogs/details/BlogDetailsView.js"));

const FormsHomeView  = lazy(() => import("../views/user/forms/FormsHomeView.js"));
const FormDetailsView  = lazy(() => import("../views/user/forms/detail/FormDetailsView.js"));

const QuizHomeView  = lazy(() => import("../views/user/quiz/QuizHomeView.js"));
const QuizWelcomeView  = lazy(() => import("../views/user/quiz/QuizWelcomeView.js"));
const QuizAttendView  = lazy(() => import("../views/user/quiz/QuizAttendView.js"));
const QuizResultHomeView  = lazy(() => import("../views/user/quiz/result/QuizResultHomeView.js"));

const ProfileHomeView = lazy(() => import("../views/user/profile/ProfileHomeView.js"));

const AdminCurriculumView = lazy(() => import("../views/admin/curriculum/CurriculumAdminView.js"));
const AdminCurriculumDetailsView = lazy(() => import("../views/admin/curriculum/details/CurriculumDetailsView.js"));
const AdminCurriculumSubmissionView = lazy(() => import("../views/admin/curriculum/details/submission/CurriculumSubmissionView.js"));
const AdminCurriculumEnrollmentsView = lazy(() => import("../views/admin/curriculum/details/enrollments/AdminCurriculumEnrollmentsView.js"));

const AdminUsersView = lazy(() => import("../views/admin/users/AdminUsersView.js"));
const AdminBlogsView = lazy(() => import("../views/admin/blogs/AdminBlogsView.js"));
const AdminSettingsView = lazy(() => import("../views/admin/settings/AdminSettingsView.js"));
const AdminUserActivityView = lazy(() => import("../views/admin/userActivity/AdminUserActivityView.js"));
const AdminDashboardView = lazy(() => import("../views/admin/dashboard/AdminDashboardView.js"));

const AdminFormsView = lazy(() => import("../views/admin/forms/AdminFormsView.js"));
const AdminFormSubmissionView = lazy(() => import("../views/admin/forms/submission/AdminFormSubmissionView.js"));

const AdminQuizView = lazy(() => import("../views/admin/quiz/AdminQuizView.js"));
const AdminQuizDetailsView = lazy(() => import("../views/admin/quiz/details/AdminQuizDetailsView.js"));

const MerchantPaymentView = lazy(() => import("../views/merchant/MerchantPaymentView.js"));
const ShopAdminView = lazy(() => import("../views/admin/shop/ShopAdminView.js"));

const ThemeRoutes = [
  {
    path: "/",
    element: <CurriculumLayout />,
    children: [
      { path: "", exact: true, element: <CurriculumsView /> }
    ],
  },
  {
    path: "/blogs",
    element: <BlogsHomeLayout />,
    children: [
      { path: "", exact: true, element: <BlogsHomeView /> }
      /*{ path: "", exact: true, element: <Navigate to="/blogs" replace />},
      { path: "/blogs", exact: true, element: <BlogsHomeView /> },*/
    ],
  },
  
  {
    path: "/blog",
    element: <BlogDetailLayout />,
    children: [
      { path: "/blog/*", exact: true, element: <BlogDetailsView />},
    ],
  },

  {
    path: "/forms",
    element: <FormsHomeLayout />,
    children: [
      { path: "", exact: true, element: <FormsHomeView /> }
    ],
  },

  {
    path: "/form",
    element: <FormDetailLayout />,
    children: [
      { path: "/form/*", exact: true, element: <FormDetailsView />},
    ],
  },

  {
    path: "/quiz",
    element: <CommonLayout />,
    children: [
      { path: "", exact: true, element: <QuizHomeView /> },
      { path: "/quiz/*", exact: true, element: <QuizHomeView /> },
      { path: "/quiz/hm/*", exact: true, element: <QuizWelcomeView/> },
      { path: "/quiz/atnd/*", exact: true, element: <QuizAttendView/> },
      { path: "/quiz/result/*", exact: true, element: <QuizResultHomeView/> },
    ],
  },

  {
    path: "/curriculum",
    element: <CurriculumDetailsLayout />,
    children: [
     /* { path: "", exact: true, element: <BlogsView /> },*/
      { path: "", exact: true, element: <CurriculumsView /> },
      { path: "/curriculum/*", exact: true, element: <CurriculumDetailsView/> },
      { path: "/curriculum/formSubmit/*", exact: true, element: <FormSubmitView /> },
      { path: "/curriculum/formView/*", exact: true, element: <FormViewerView /> }
    ],
  },

  {
    path: "/dss",
    element: <DataSecurityLayout />,
    children: [
      { path: "/dss/login", exact: true, element:<LoginView />},
      { path: "/dss/forgot-username", exact: true, element:<ForgotUserNameView />},
      { path: "/dss/forgot-password", exact: true, element:<ForgotPasswordView />},
      { path: "/dss/register", exact: true, element:<RegisterView />},
      { path: "/dss/register/success", exact: true, element:<RegisterSuccessView />},
      { path: "/dss/profile/activate", exact: true, element:<ProfileActivationView />},
      { path: "/dss/forbidden", exact: true, element:<UnauthorizedView/>},
      { path: "/dss/completeProfile", exact: true, element:<CompleteProfileView/>}
    ]
  },
  {
    path: "/user",
    element: <Authentication><ProfileLayout /></Authentication>,
    children: [
      { path: "profile", exact: true, element: <Authorization><ProfileHomeView viewId="ProfileView" /></Authorization>},
    ]
  },
  {
    path: "/admin",
    element: <Authentication><AdminHomeLayout /></Authentication>,
    children: [
     // { path: "", exact: true,  element: <Navigate to="dashboard" replace />},
      { path: "curriculums", exact: true, element:<Authorization><AdminCurriculumView viewId="AdminCurriculumView"/></Authorization>},
      { path: "blogs", exact: true, element:<Authorization><AdminBlogsView viewId="AdminBlogsView"/></Authorization>},
      { path: "settings", exact: true, element:<Authorization><AdminSettingsView viewId="AdminSettingsView"/></Authorization>},
      { path: "activity", exact: true, element:<Authorization><AdminUserActivityView viewId="AdminUserActivityView"/></Authorization>},
      { path: "dashboard", exact: true, element:<Authorization><AdminDashboardView viewId="AdminDashboardView"/></Authorization>},
      { path: "forms", exact: true, element:<Authorization><AdminFormsView viewId="AdminFormsView"/></Authorization>},
      { path: "quiz", exact: true, element:<Authorization><AdminQuizView viewId="AdminQuizView"/></Authorization>},
      { path: "shop", exact: true, element:<Authorization><ShopAdminView viewId="ShopAdminView"/></Authorization>},
    ]
  },
  {
    path: "/admin/form",
    element: <Authentication><AdminFormDetailsLayout/></Authentication>,
    children: [
      { path: "/admin/form/sub/*", exact: true,  element: <Authorization><AdminFormSubmissionView viewId="AdminFormSubmissionView" /></Authorization>},
    ]
  },

  {
    path: "/admin/quiz",
    element: <Authentication><AdminFormDetailsLayout/></Authentication>,
    children: [
      { path: "/admin/quiz/*", exact: true,  element: <Authorization><AdminQuizDetailsView viewId="AdminQuizDetailsView" /></Authorization>},
    ]
  },

  {
    path: "/admin/curriculum",
    element: <Authentication><AdminCurriculumDetailsLayout/></Authentication>,
    children: [
      /*{ path: "", exact: true,  element: <Navigate to="*" replace />},*/
      { path: "*", exact: true, element: <Authorization><AdminCurriculumDetailsView viewId="AdminCurriculumDetailsView"/></Authorization> },
      { path: "/admin/curriculum/sub/*", exact: true,  element: <Authorization><AdminCurriculumSubmissionView viewId="FormView" /></Authorization>},
      { path: "/admin/curriculum/enrollments/*", exact: true, element: <Authorization><AdminCurriculumEnrollmentsView viewId="EnrollmentsView" /></Authorization>}
    ]
  },
  {
    path: "/admin/users",
    element: <Authentication><AdminUsersLayout/></Authentication>,
    children: [
      { path: "", exact: true, element:<Authorization><AdminUsersView viewId="UsersView"/></Authorization>},
      { path: "/admin/users/*", exact: true, element:<Authorization><AdminUsersView viewId="UsersView"/></Authorization>}
    ]
  },
  {
    path: "/merchant/",
    element: <DataSecurityLayout />,
    children: [
     { path: "auth", exact: true, element:<LoginView />},
     { path: "pay", exact: true, element:<MerchantPaymentView />},
    ]
  }
  
];

export default ThemeRoutes;
